import React from 'react';

import { TemplateSwitch } from 'src/templates';

import { marketingCmsClient } from 'src/lib/contentful-client';
import { ContentfulTemplates } from 'src/lib/constants';
import { optimizeContentfulImages } from 'src/lib/image-helpers';

const UseCasePage = (props) => {
  return <TemplateSwitch {...props} />;
};

// https://nextjs.org/docs/basic-features/data-fetching#getstaticprops-static-generation
export async function getStaticPaths() {
  // https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/entries
  const entries = await marketingCmsClient.getEntries({
    content_type: ContentfulTemplates.USE_CASE,
    'fields.locale': 'US',
  });

  const paths = entries.items
    .map((entry) => {
      if (entry.fields.pageSlug && entry.fields.locale) {
        return { params: { index: entry.fields.pageSlug } };
      }
      return null;
    })
    .filter((entry) => !!entry);
  return {
    paths,
    fallback: false,
  };
}

// https://nextjs.org/docs/basic-features/data-fetching#getstaticprops-static-generation
export async function getStaticProps({ params, preview }) {
  // https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/entries
  const entries = await marketingCmsClient.getEntries({
    content_type: ContentfulTemplates.USE_CASE,
    'fields.locale': 'US',
    include: 10,
  });
  const data = entries.items.find(
    (entry) => entry.fields.pageSlug && entry.fields.pageSlug === params.index,
  );

  return { props: { ...optimizeContentfulImages(data), preview: !!preview } };
}

export default UseCasePage;
